import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M17.5 13C19.433 13 21 14.567 21 16.5C21 18.433 19.433 20 17.5 20C15.8246 20 14.4255 18.8224 14.082 17.25H5V15.75H14.082C14.4255 14.1776 15.8246 13 17.5 13ZM17.5 14.5C16.3954 14.5 15.5 15.3954 15.5 16.5C15.5 17.6046 16.3954 18.5 17.5 18.5C18.6046 18.5 19.5 17.6046 19.5 16.5C19.5 15.3954 18.6046 14.5 17.5 14.5ZM6.5 3.5C8.17545 3.5 9.57452 4.67756 9.91797 6.25H19V7.75H9.91797C9.57452 9.32244 8.17545 10.5 6.5 10.5C4.567 10.5 3 8.933 3 7C3 5.067 4.567 3.5 6.5 3.5ZM6.5 5C5.39543 5 4.5 5.89543 4.5 7C4.5 8.10457 5.39543 9 6.5 9C7.60457 9 8.5 8.10457 8.5 7C8.5 5.89543 7.60457 5 6.5 5Z",
			fill: "currentColor"
		})
	})
});
export default SvgFilter;
